<template>
  <div class="all-product">
    <modalFilter
      ref="modalFilter"
      :listSort="listSort"
      :category="category"
      :categorySelected="categoryFilter.value"
      :priceMinFilter="priceMinFilter"
      :priceMaxFilter="priceMaxFilter"
      @action="filterFromModal"
      :storePartner="official_store"
    ></modalFilter>
    <v-col class="pt-5">
      <v-row>
        <v-col cols="2" class="pr-0 d-none d-md-block">
          <div class="pt-3"></div>
          <div class="d-flex font-weight-bold">
            <v-icon color>mdi-filter</v-icon>
            <div class="pl-2 text-uppercase">Filter</div>
          </div>
          <div class="pt-3 text-body-2">
            <v-expansion-panels tile multiple accordion v-model="panel" class="accordion-filter">
              <!-- <div v-show="$route.query.type == 'store'">
                <v-expansion-panel id="store-type">
                  <v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2"
                    >Tipe Toko</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-list class="py-0">
                      <v-list-item dense class="px-0">
                        <v-list-item-title>
                          <v-checkbox
                            v-model="official_store"
                            @change="cari"
                            color="orange darken-1"
                            hide-details
                          >
                            <template v-slot:label>
                              <strong class="orange--text text--darken-1">Store Partner</strong>
                            </template>
                          </v-checkbox>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </div> -->
              <div v-show="$route.query.type == 'product'">
                <v-expansion-panel id="category">
                  <v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2"
                    >Kategori ({{ category.length }})</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-list class="py-0">
                      <v-list-item
                        @click="selectCategory(item.product_category_slug)"
                        dense
                        v-for="item in categoryList"
                        :key="item.product_category_slug"
                        class="px-0"
                      >
                        <v-list-item-title class="d-flex">
                          <v-img
                            class="mr-5"
                            :src="item.product_category_image"
                            max-height="20"
                            max-width="20"
                          ></v-img>
                          {{ item.product_category_name }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                    <v-btn
                      text
                      width="100%"
                      depressed
                      class="mt-1 rounded-lg font-weight-bold"
                      @click="showMorecategory = !showMorecategory"
                    >
                      <v-icon left>{{
                        showMorecategory ? "mdi-chevron-up" : "mdi-chevron-down"
                      }}</v-icon>
                      {{ showMorecategory ? "Sembunyikan" : "Lebih Banyak" }}
                    </v-btn>
                    <!-- <v-treeview :items="items" v-for="i in 3" :key="i" class="text-caption"></v-treeview> -->
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- <v-expansion-panel id="category">
                  <v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2"
                    >Tipe Toko</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-list class="py-0">
                      <v-list-item dense class="px-0">
                        <v-list-item-title>
                          <v-checkbox
                            v-model="official_store"
                            @change="cari"
                            color="orange darken-1"
                            hide-details
                          >
                            <template v-slot:label>
                              <strong class="orange--text text--darken-1">Store Partner</strong>
                            </template>
                          </v-checkbox>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel> -->
                <v-expansion-panel id="price">
                  <v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2"
                    >Harga</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <div class="pt-2">
                      <v-currency-field
                        v-model="priceMinFilter.value"
                        label="Minimum"
                        hide-details
                        class="rounded-lg text-body-2"
                      ></v-currency-field>
                    </div>
                    <div class="pt-2">
                      <v-currency-field
                        v-model="priceMaxFilter.value"
                        label="Maximum"
                        hide-details
                        class="rounded-lg text-body-2"
                      ></v-currency-field>
                    </div>
                    <div class="pt-2">
                      <v-btn
                        color="black"
                        width="100%"
                        depressed
                        class="rounded-lg font-weight-bold white--text"
                        @click="cari"
                        >Terapkan</v-btn
                      >
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </div>
              <v-expansion-panel id="location" v-if="false">
                <v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2"
                  >Lokasi</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-checkbox class="mt-0 small-check" hide-details label="Yogyakarta"></v-checkbox>
                  <v-checkbox class="mt-0 small-check" hide-details label="Semarang"></v-checkbox>
                  <v-checkbox class="mt-0 small-check" hide-details label="Solo"></v-checkbox>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel id="courier" v-if="false">
                <v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2"
                  >Pengiriman</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-checkbox
                    v-for="cour in courList"
                    :key="cour.courier_code"
                    v-model="selectedCour"
                    class="mt-0 small-check"
                    hide-details
                    :value="cour.courier_code"
                    :label="cour.courier_name"
                  ></v-checkbox>
                  <v-btn
                    color="primary"
                    width="100%"
                    depressed
                    class="mt-1 rounded-lg font-weight-bold"
                    @click="showMoreCour = !showMoreCour"
                    >{{ showMoreCour ? "Sembunyikan" : "Lebih Banyak" }}</v-btn
                  >
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel id="rating" v-if="false">
                <v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2"
                  >Rating</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <v-row>
                    <div class="pl-3">
                      <v-checkbox class="mt-0 small-check" hide-details></v-checkbox>
                    </div>
                    <div>
                      <div class="pt-1">
                        <v-icon color="yellow darken-1" v-for="i in 4" :key="'star1' + i"
                          >mdi-star</v-icon
                        >
                        <v-icon color="grey lighten-1">mdi-star</v-icon>
                      </div>
                      <div class="pl-1 text-caption">Keatas</div>
                    </div>
                  </v-row>
                  <v-row class="mt-1">
                    <div class="pl-3">
                      <v-checkbox class="mt-0 small-check" hide-details></v-checkbox>
                    </div>
                    <div>
                      <div class="pt-1">
                        <v-icon color="yellow darken-1" v-for="i in 3" :key="'star2' + i"
                          >mdi-star</v-icon
                        >
                        <v-icon color="grey lighten-1" v-for="i in 2" :key="'star3' + i"
                          >mdi-star</v-icon
                        >
                      </div>
                      <div class="pl-1 text-caption">Keatas</div>
                    </div>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-col>
        <v-col cols="12" md="10" class="pl-md-5">
          <div>
            <v-list class="py-0">
              <v-list-item dense class="px-0">
                <div class="text-right d-block d-md-none mr-3">
                  <v-btn outlined height="40" color="grey" class="rounded-lg" @click="clickFilter">
                    <v-icon color="grey darken-1">mdi-filter-outline</v-icon>
                    <span class="text-body-2 text-capitalize grey--text text--darken-4"
                      >Filter</span
                    >
                  </v-btn>
                </div>
                <div class="d-block d-md-block">
                  <v-tabs color="black" v-model="tabMenu" @change="changeTab">
                    <v-tab class="text-subtitle-1 font-weight-bold">Produk</v-tab>
                    <v-tab class="text-subtitle-1 font-weight-bold">Toko</v-tab>
                  </v-tabs>
                </div>
                <v-spacer></v-spacer>
                <v-chip
                  v-if="categoryFilter.value"
                  class="ma-2 d-none d-md-block"
                  close
                  @click:close="removeCategory"
                  >{{ slugToNormal(categoryFilter.value) }}</v-chip
                >
                <v-chip
                  v-if="productNameFilter.value"
                  class="ma-2 d-none d-md-block"
                  close
                  @click:close="removeProduct"
                  >{{ productNameFilter.value }}</v-chip
                >
                <v-chip
                  v-if="storeNameFilter.value"
                  class="ma-2 d-none d-md-block"
                  close
                  @click:close="removeStore"
                  >{{ storeNameFilter.value }}</v-chip
                >
                <div v-if="false">
                  <div class="pt-1">
                    <div class="font-weight-bold text-body-2">Urutkan :</div>
                  </div>
                  <div class="pt-1 ml-2">
                    <v-btn
                      color="primary"
                      width="90"
                      height="45"
                      class="rounded-lg text-capitalize font-weight-bold text-body-2"
                      depressed
                      >Terkait</v-btn
                    >
                  </div>
                  <div class="pt-1 ml-2">
                    <v-btn
                      color="primary"
                      width="90"
                      height="45"
                      class="rounded-lg text-capitalize font-weight-bold text-body-2"
                      depressed
                      >Terbaru</v-btn
                    >
                  </div>
                  <div class="pt-1 ml-2">
                    <v-btn
                      color="primary"
                      width="90"
                      height="45"
                      class="rounded-lg text-capitalize font-weight-bold text-body-2"
                      depressed
                      >Terlaris</v-btn
                    >
                  </div>
                </div>
                <div class="pt-md-1 ml-2">
                  <v-autocomplete
                    v-if="$route.query.type == 'product'"
                    @input="cari"
                    v-model="sort"
                    :items="listSort"
                    item-text="sortLabel"
                    return-object
                    outlined
                    dense
                    hide-details
                    placeholder="Urutkan dari"
                    class="rounded-lg text-body-2"
                    no-data-text="Belum ada data tersedia"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-if="$route.query.type == 'store'"
                    @input="cari"
                    v-model="sort"
                    :items="listSortStore"
                    item-text="sortLabel"
                    return-object
                    outlined
                    dense
                    hide-details
                    placeholder="Urutkan dari"
                    class="rounded-lg text-body-2"
                    no-data-text="Belum ada data tersedia"
                  ></v-autocomplete>
                </div>
              </v-list-item>
            </v-list>
          </div>
          <div class="pt-5" v-if="$route.query.type == 'product'">
            <div v-if="products.length > 0">
              <v-row class="ml-0">
                <v-col
                  class="pl-0 pt-0"
                  cols="6"
                  md="3"
                  sm="3"
                  v-for="product in products"
                  :key="product.product_id"
                >
                  <v-hover v-slot:default="{ hover }">
                    <router-link
                      v-if="product.product_type == 'internal'"
                      :to="{
                        name: 'exclusive-product',
                        params: { id: product.product_id, slug: product.product_slug_name }
                      }"
                      class="text-deco"
                    >
                      <v-card
                        outlined
                        height="350"
                        class="rounded-lg product-carousel"
                        :elevation="hover ? 4 : 0"
                      >
                        <div class="pa-2">
                          <v-img
                            :src="
                              product.product_image[0]
                                ? product.product_image[0]
                                : '/assets/product/default.png'
                            "
                            height="150"
                            class="rounded-lg"
                          ></v-img>
                        </div>
                        <v-col class="grey--text text--darken-2 text-body-2">
                          <div class="product-text">{{ product.product_name }}</div>
                          <div class="product-price mt-2">
                            <div
                              class="text-decoration-line-through font-size-12 pink--text"
                              v-if="product.product_price != product.product_price_origin"
                            >
                              Rp {{ product.product_price_origin | toNumber }}
                            </div>
                            <div class="text-h6">Rp {{ product.product_price | toNumber }}</div>
                            <div class="text-caption">
                              <span
                                v-if="product.product_enable_discount == '1'"
                                class="red white--text"
                                >{{ product.product_discount_percent | toNumber }}%</span
                              >
                              &nbsp;
                              <strike v-if="product.product_enable_discount == '1'"
                                >Rp {{ product.product_gross | toNumber }}</strike
                              >
                            </div>
                            <!-- <div class="text-caption" v-if="product.am.product_fee > 0">
                              <b> GM: Rp {{ product.am.total | toNumber }} </b>
                            </div> -->
                          </div>
                          <div class="pt-2">
                            <div class="primary--text text--darken-2">
                              {{ product.store_city_name }}
                            </div>
                            <!--<div class="d-flex" v-if="product.product_rating > 0">
															<v-icon small color="yellow darken-1">mdi-star</v-icon>
															<span class="pl-1">{{product.product_rating}}({{product.product_review_count}})</span>
														</div>
														<div class="d-flex" v-else>
															Belum ada rating
                            </div>-->
                            <div class="pt-1 d-flex" v-if="false">
                              <star-rating :rating="product.product_rating"></star-rating>
                              <!-- <v-rating empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-half-full" hover length="5" readonly size="12" color="yellow darken-1" :value="parseInt(product.product_rating) / parseInt(product.product_review_count)"></v-rating> -->
                              <span class="pl-1 text-caption"
                                >({{ product.product_review_count | toNumber }})</span
                              >
                            </div>
                          </div>
                        </v-col>
                      </v-card>
                    </router-link>
                    <router-link
                      v-else
                      :to="{
                        name: 'product-detail',
                        params: { id: product.product_id, slug: product.product_slug_name }
                      }"
                      class="text-deco"
                    >
                      <v-card outlined height="350" class="rounded-lg" :elevation="hover ? 4 : 0">
                        <div class="pa-2">
                          <v-img
                            :src="
                              product.product_image[0]
                                ? product.product_image[0]
                                : '/assets/product/default.png'
                            "
                            height="150"
                            class="rounded-lg"
                          ></v-img>
                        </div>
                        <v-col class="grey--text text--darken-2 text-body-2">
                          <div class="product-text">{{ product.product_name }}</div>
                          <div class="product-price mt-2">
                            <div
                              class="text-decoration-line-through font-size-12 pink--text"
                              v-if="product.product_price != product.product_price_origin"
                            >
                              Rp {{ product.product_price_origin | toNumber }}
                            </div>
                            <div class="text-h6">Rp {{ product.product_price | toNumber }}</div>
                          </div>

                          <div class="pt-2">
                            <div class="text-caption">
                              <span
                                v-if="product.product_enable_discount == '1'"
                                class="red white--text"
                                >{{ product.product_discount_percent | toNumber }}%</span
                              >
                              &nbsp;
                              <strike v-if="product.product_enable_discount == '1'"
                                >Rp {{ product.product_gross | toNumber }}</strike
                              >
                            </div>
                            <!-- <div class="text-caption" v-if="product.am.product_fee > 0">
                              <b> GM: Rp {{ product.am.total | toNumber }} </b>
                            </div> -->
                            <div class="primary--text text--darken-2">
                              {{ product.store_city_name }}
                              <!-- <v-icon
                                v-if="product.store_is_b2b == 'true' "
                                dense
                                color="orange darken-1"
                              >mdi-star-circle</v-icon> -->
                            </div>
                            <!--<div class="d-flex" v-if="product.product_rating > 0">
															<v-icon small color="yellow darken-1">mdi-star</v-icon>
															<span class="pl-1">{{product.product_rating}}({{product.product_review_count}})</span>
														</div>
														<div class="d-flex" v-else>
															Belum ada rating
                            </div>-->
                            <div class="pt-1 d-flex" v-show="false">
                              <!-- <star-rating :rating="product.product_rating"></star-rating> -->
                              <!-- <v-rating empty-icon="mdi-star-outline" full-icon="mdi-star" half-icon="mdi-star-half-full" hover length="5" readonly size="12" color="yellow darken-1" :value="parseInt(product.product_rating) / parseInt(product.product_review_count)"></v-rating> -->
                              <!-- <span
                                class="pl-1 text-caption"
                              >({{ product.product_review_count | toNumber }})</span> -->
                            </div>
                          </div>
                        </v-col>
                      </v-card>
                    </router-link>
                  </v-hover>
                </v-col>
              </v-row>
              <v-row class="py-4 justify-center">
                <v-pagination
                  v-if="productsPagination.total_page > 1"
                  v-model="page"
                  @input="changePage('product')"
                  :length="productsPagination.total_page"
                  class="elevation-0"
                ></v-pagination>
              </v-row>
            </div>
            <div v-else>
              <v-row class="justify-center">
                <v-col cols="7" md="4">
                  <v-img width="100%" src="/assets/icons/ilus-search.svg"></v-img>
                </v-col>
              </v-row>
              <div class="text-center pb-3">
                <div class="pt-1 text-body-1 font-weight-bold">
                  Oops.. produk yang Anda cari tidak tersedia
                </div>
              </div>
            </div>
          </div>
          <div class="pt-5" v-if="$route.query.type == 'store'">
            <div v-if="store.length > 0">
              <v-row class="ml-0">
                <v-col class="pl-0 pt-0" cols="6" sm="4" md="3" v-for="(data, i) in store" :key="i">
                  <v-hover v-slot:default="{ hover }">
                    <router-link
                      :to="{ name: 'store-detail', params: { slug: data.store_slug } }"
                      class="text-deco"
                    >
                      <v-card outlined class="rounded-lg" :elevation="hover ? 4 : 0">
                        <div class="pa-3 text-right">
                          <v-badge
                            v-if="data.store_is_b2b == 'true'"
                            color="orange darken-1"
                            content="Store Partner"
                            inline
                          ></v-badge>
                        </div>
                        <v-img
                          width="100%"
                          :src="
                            data.store_image ? data.store_image : '/assets/seller/default-toko.svg'
                          "
                          height="150"
                          class="rounded-lg"
                        ></v-img>
                        <v-col class="grey--text text--darken-2 text-body-2 text-center">
                          <div class="font-weight-bold text-uppercase">{{ data.store_name }}</div>
                          <div class="pt-1 font-weight-bold" v-if="false">
                            {{ data.user_mobilephone }}
                          </div>
                          <div class="pt-2 primary--text text--darken-2">
                            {{ data.store_city_name }}
                          </div>
                        </v-col>
                      </v-card>
                    </router-link>
                  </v-hover>
                </v-col>
              </v-row>
              <v-row class="pt-4 justify-center">
                <v-pagination
                  v-if="storePagination.total_page > 1"
                  v-model="page"
                  @input="changePage('store')"
                  :length="storePagination.total_page"
                  class="elevation-0"
                ></v-pagination>
              </v-row>
            </div>
            <div v-else>
              <v-row class="justify-center">
                <v-col cols="7" md="4">
                  <v-img width="100%" src="/assets/icons/ilus-search.svg"></v-img>
                </v-col>
              </v-row>
              <div class="text-center pb-3">
                <div class="pt-1 text-body-1 font-weight-bold">
                  Oops.. toko yang Anda cari tidak tersedia
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import StarRating from "@/components/StarRating";
import modalFilter from "@/views/store/product/ModalFilter";

export default {
  components: {
    StarRating,
    modalFilter
  },
  data() {
    return {
      panel: [0, 1, 2, 3, 4],
      showMoreCour: false,
      showMorecategory: false,
      tabMenu: 0,
      official_store: false,
      items: [
        {
          id: 1,
          name: "Komputer & Aksesoris",
          children: [
            { id: 2, name: "Komputer" },
            { id: 3, name: "Aksesoris" }
          ]
        }
      ],
      listSort: [
        {
          sortBy: "product_price",
          sortDir: "ASC",
          sortLabel: "Harga Terendah"
        },
        {
          sortBy: "product_price",
          sortDir: "DESC",
          sortLabel: "Harga Tertinggi"
        },
        {
          sortBy: "product_input_datetime",
          sortDir: "DESC",
          sortLabel: "Produk Terbaru"
        },
        {
          sortBy: "product_sold_count",
          sortDir: "DESC",
          sortLabel: "Produk Terlaris"
        },
        {
          sortBy: "product_view_count",
          sortDir: "DESC",
          sortLabel: "Produk Terpopuler"
        }
      ],
      listSortStore: [
        {
          sortBy: "store_trx_count",
          sortDir: "DESC",
          sortLabel: "Toko Terlaris"
        }
      ],
      params: [],
      page: 1,
      limit: 8,
      sort: {},
      sortBy: "",
      sortDir: "",
      storeNameFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "store_name"
      },
      productNameFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "product_name"
      },
      categoryFilter: {
        value: "",
        comparison: "=",
        type: "string",
        field: "product_category_slug"
      },
      priceMinFilter: {
        value: null,
        comparison: ">=",
        type: "numeric",
        field: "product_price"
      },
      priceMaxFilter: {
        value: null,
        comparison: "<=",
        type: "numeric",
        field: "product_price"
      },
      storeExclusive: {
        value: "",
        comparison: "like",
        type: "string",
        field: "store_is_b2b"
      },
      selectedCour: [],
      courierFilter: {
        value: [],
        comparison: "=",
        type: "string",
        field: "store_courier"
      },
      ratingFilter: {
        value: "",
        comparison: ">=",
        type: "string",
        field: "product_rating"
      }
    };
  },
  computed: {
    ...mapState("category", ["category", "categoryPagination"]),
    ...mapState("store", ["store", "storePagination"]),
    ...mapState("productExternal", [
      "productInternal",
      "productInternalPagination",
      "products",
      "productsPagination"
    ]),
    ...mapState("options", ["courier"]),

    courList() {
      let cour = [];
      if (this.courier.length > 0) {
        if (this.showMoreCour) {
          cour = this.courier;
        } else {
          cour = this.courier.slice(0, 3);
        }
      }
      return cour;
    },
    categoryList() {
      let category = [];
      if (this.category.length > 0) {
        if (this.showMorecategory) {
          category = this.category;
        } else {
          category = this.category.slice(0, 3);
        }
      }
      return category;
    }
  },
  methods: {
    ...mapActions("productExternal", ["getProductsSearch"]),
    ...mapActions("store", ["getStore"]),
    ...mapActions("category", ["getCategory"]),
    ...mapActions("options", ["getCourier"]),

    async changeTab() {
      this.sort = {};
      let tab = await this.tabMenu;
      if (tab == 0) {
        this.storeNameFilter.value = "";
        this.$router.push({
          name: "search",
          query: { type: "product", search: this.$route.query.search }
        });
      } else if (tab == 1) {
        this.productNameFilter.value = "";
        this.$router.push({
          name: "search",
          query: { type: "store", search: this.$route.query.search }
        });
      }
    },
    slugToNormal(val) {
      return val.replace(/-/g, " ");
    },
    changePage(type) {
      if (type == "product") {
        this.getProductsSearch(
          this.queryString({
            limit: this.limit,
            page: this.page,
            params: this.params,
            sort: this.sortBy,
            dir: this.sortDir
          })
        ).then(() => {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        });
      } else if (type == "store") {
        this.getStore(
          this.queryString({
            limit: this.limit,
            page: this.page,
            params: this.params,
            sort: this.sortBy,
            dir: this.sortDir
          })
        ).then(() => {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        });
      }
    },
    selectCategory(slug) {
      this.categoryFilter.value = slug;
      this.cari();
    },
    removeCategory() {
      this.categoryFilter.value = "";
      this.cari();
    },
    removeProduct() {
      this.productNameFilter.value = "";
      this.$router.replace({
        name: "search",
        query: { type: "product" }
      });
    },
    removeStore() {
      this.storeNameFilter.value = "";
      this.$router.replace({
        name: "search",
        query: { type: "store" }
      });
    },
    async filterFromModal(val) {
      this.categoryFilter.value = await val.category;
      this.priceMaxFilter = await val.priceMax;
      this.priceMinFilter = await val.priceMin;
      this.official_store = await val.storePartner;
      // this.sort.sortBy = await val.sort.sortBy
      // this.sort.sortDir = await val.sort.sortDir
      await this.cari();
    },
    cari() {
      this.params = [];
      this.page = 1;
      if (this.$route.query.type == "product") {
        if (this.categoryFilter.value) this.params.push(this.categoryFilter);
        if (this.priceMinFilter.value) this.params.push(this.priceMinFilter);
        if (this.priceMaxFilter.value) this.params.push(this.priceMaxFilter);
        if (this.courierFilter.value) {
          if (this.courierFilter.value.length > 0) {
            this.courierFilter.value.join("::");
            this.params.push(this.courierFilter);
          }
        }
        if (this.official_store == true) {
          this.storeExclusive.value = "true";
          this.params.push(this.storeExclusive);
        }
        if (this.ratingFilter.value) this.params.push(this.ratingFilter);

        if (this.productNameFilter.value) this.params.push(this.productNameFilter);

        this.sortBy = this.sort.sortBy;
        this.sortDir = this.sort.sortDir;
        this.getProductsSearch(
          this.queryString({
            limit: this.limit,
            page: this.page,
            params: this.params,
            sort: this.sortBy,
            dir: this.sortDir
          })
        );
      } else if (this.$route.query.type == "store") {
        if (this.official_store == true) {
          this.storeExclusive.value = "true";
          this.params.push(this.storeExclusive);
        }
        if (this.storeNameFilter.value) {
          this.params.push(this.storeNameFilter);
        }
        this.sortBy = this.sort.sortBy;
        this.sortDir = this.sort.sortDir;
        this.getStore(
          this.queryString({
            limit: this.limit,
            page: this.page,
            params: this.params,
            sort: this.sortBy,
            dir: this.sortDir
          })
        );
      }
    },
    resetFilter() {
      this.categoryFilter.value = "";
      this.priceMinFilter.value = null;
      this.priceMaxFilter.value = null;
      this.courierFilter.value = [];
      this.ratingFilter.value = "";
      this.cari();
    },
    clickFilter() {
      this.$refs.modalFilter.modalShow();
    }
  },
  watch: {
    $route(val) {
      if (val.query.search) {
        if (val.query.type == "product") {
          this.tabMenu = 0;
          this.storeNameFilter.value = "";
          this.productNameFilter.value = val.query.search.replace(/-/g, " ");
        } else if (val.query.type == "store") {
          this.tabMenu = 1;
          this.productNameFilter.value = "";
          this.storeNameFilter.value = val.query.search.replace(/-/g, " ");
        }
      }
      this.resetFilter();
    },
    selectedCour(val) {
      this.courierFilter.value = val;
      this.cari();
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", "Produk");
    this.getCourier();
    this.getCategory();
  },
  mounted() {
    if (this.$route.query.type == "product") {
      this.tabMenu = 0;
      if (this.$route.query.category) {
        this.categoryFilter.value = this.$route.query.category;
      }
      if (this.$route.query.search) {
        this.storeNameFilter.value = "";
        this.productNameFilter.value = this.$route.query.search.replace(/-/g, " ");
      }
    } else if (this.$route.query.type == "store") {
      this.tabMenu = 1;
      if (this.$route.query.search) {
        this.productNameFilter.value = "";
        this.storeNameFilter.value = this.$route.query.search.replace(/-/g, " ");
      }
      if (this.$route.query.is_partner) {
        this.official_store = true;
      }
    }
    this.cari();
  }
};
</script>
